<template>
  <div>
    <v-layout wrap justify-end>
      <v-flex shrink>
        <v-btn
          color="grey"
          outline
          :loading="isExporting"
          class="ma-0"
          @click="isExportDialogVisible = true"
        >
          <v-icon>ios_share</v-icon>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-end class="mt-3">
      <v-flex shrink>
        <v-btn
          color="primary"
          class="ma-0"
          @click="isAdvancedSearchVisible = !isAdvancedSearchVisible"
        >
          <v-icon>search</v-icon> {{ $t('advanced search') }}
          <v-icon v-if="isAdvancedSearchVisible">expand_less</v-icon>
          <v-icon v-else>expand_more</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <SurveyAdvancedSearch v-if="survey && isAdvancedSearchVisible" class="mt-3" />

    <SurveyTable v-if="survey" class="mt-3" />

    <ExportGroup
      v-model="isExportDialogVisible"
      :total="items.length"
      :limit="1000"
      filename="survey"
      @onExport="handleExport"
    />
  </div>
</template>

<script>
import surveyApi from '@/api/survey'
import ExportGroup from '@/components/elements/ExportGroup.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import SurveyAdvancedSearch from './SurveyAdvancedSearch.vue'
import SurveyTable from './SurveyTable.vue'

export default {
  components: { SurveyAdvancedSearch, SurveyTable, ExportGroup },
  inject: ['surveyId'],
  provide() {
    return {
      isLoading: () => this.isLoading,
      items: () => this.items,
      pagination: () => this.pagination,
      setPagination: (value) => (this.pagination = value),
      filters: () => this.filters,
      setFilters: (value) => (this.filters = value),
      survey: () => this.survey,
      viewedItem: () => this.viewedItem,
      setViewedItem: (value) => (this.viewedItem = value)
    }
  },
  data() {
    return {
      isLoading: false,
      isAdvancedSearchVisible: false,
      items: [],
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      filters: null,
      survey: null,
      viewedItem: null,
      isExporting: false,
      isExportDialogVisible: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    survey(value) {
      if (!value) return

      this.filters = {
        channel: { value: 'all', text: this.$t('All') },
        ...Object.keys(value.filter_json).reduce((prev, key) => {
          prev[key] = { value: 'all', text: this.$t('All') }
          return prev
        }, {}),
        start_date: null,
        end_date: null
      }
    },
    filters(value) {
      if (!value) return

      this.fetchSurveyAnswers()
    }
  },
  created() {
    this.fetchSurveyInfo()
  },
  methods: {
    async fetchSurveyInfo() {
      try {
        const response = await surveyApi.getInfo({
          params: {
            page_id: this.selectedBot.pageid,
            id: this.surveyId()
          }
        })

        if (response.status === 200) {
          this.survey = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async fetchSurveyAnswers() {
      try {
        this.isLoading = true

        const response = await surveyApi.getAnswers({
          params: {
            page_id: this.selectedBot.pageid,
            survey_id: this.surveyId(),
            channel: this.filters.channel.value === 'all' ? '' : this.filters.channel.value,
            ...Object.keys(this.survey.filter_json).reduce((prev, key) => {
              prev[key] = this.filters[key].value === 'all' ? '' : this.filters[key].value
              return prev
            }, {}),
            datefrom: this.filters.start_date
              ? moment(this.filters.start_date).format('YYYY-MM-DD')
              : '',
            dateto: this.filters.end_date ? moment(this.filters.end_date).format('YYYY-MM-DD') : ''
          }
        })

        if (response.status === 200) {
          this.pagination = { ...this.pagination, page: 1 }
          this.items = response.data.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async handleExport({ limit, offset, submitData }) {
      try {
        this.isExporting = true

        const response = await surveyApi.getExportedAnswers({
          params: {
            page_id: this.selectedBot.pageid,
            survey_id: this.surveyId(),
            limit,
            offset,
            ...Object.keys(this.survey.filter_json).reduce((prev, key) => {
              prev[key] = this.filters[key].value === 'all' ? '' : this.filters[key].value
              return prev
            }, {}),
            datefrom: this.filters.start_date
              ? moment(this.filters.start_date).format('YYYY-MM-DD')
              : '',
            dateto: this.filters.end_date ? moment(this.filters.end_date).format('YYYY-MM-DD') : ''
          }
        })

        if (response.status === 200 && response.data.data) {
          const rows = response.data.data.map((item) => ({
            ชื่อ: [item.first_name, item.last_name].join(' ').trim(),
            ช่องทาง: item.channel,
            PDPA: item.pdpa_consent ? 'ยินยอม' : 'ไม่ยินยอม',
            ข้อเสนอแนะ: item.feedback,
            ...item.answerList.reduce((prev, question) => {
              prev[question.question] = question.user_answer
              return prev
            }, {}),
            วันที่สร้าง: item.created_at ? moment(item.created_at).format('YYYY-MM-DD HH:mm') : ''
          }))

          submitData(rows)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/Survey/Survey.vue